import classnames from 'classnames'

import styles from './styles.module.scss'

type CardChipProps = {
  content: string
  className?: string
}

export const CardChip = ({ content, className }: CardChipProps) => {
  return (
    <div className={classnames(styles['card-chip-container'], className)}>
      <p className={styles['card-chip-content']}>#{content}</p>
    </div>
  )
}

export default CardChip
